import curd from '../curd'

const BASE_PATH = '/das'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/DAS.js